import React from 'react';
import transition from 'transitionjs';

export default class Flipper extends React.Component {

    constructor(props) {
        super(props);

        this.flipElement = null;
        this.state = {
            flipped: false
        };
    }

    flip(halfwayCallback, completeCallback) {
        let fromFirst, toFirst, fromSecond, toSecond;
        if (this.state.flipped) {
            fromFirst = 'rotateY(180deg)';
            toFirst = 'rotateY(270deg)';
            fromSecond = 'rotateY(270deg)';
            toSecond = 'rotateY(360deg)';
        } else {
            fromFirst = 'rotateY(0.1deg)';
            toFirst = 'rotateY(90deg)';
            fromSecond = 'rotateY(90deg)';
            toSecond = 'rotateY(180deg)';
        }
        transition.begin(this.flipElement, `transform ${fromFirst} ${toFirst} 200ms ease-in`).promise
            .then(({element, finished}) => {
                if (typeof halfwayCallback === "function") {
                    halfwayCallback();
                }
                this.setState({
                    flipped: !this.state.flipped
                });
                return transition.begin(element, `transform ${fromSecond} ${toSecond} 200ms ease-out`).promise;
            })
            .then(({element, finished}) => {
                if (typeof completeCallback === "function") {
                    completeCallback();
                }
            });
    }

    render() {
        return (
            <div style={{perspective: "1000px", ...this.props.style}}>
                <div ref={(elm) => { this.flipElement = elm; }}>
                    <div style={{transform: this.state.flipped ? "rotateY(180deg)" : "rotateY(0deg)" }}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/Flipper.js